import {
  Grid,
  Box,
  Typography,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  Stack,
  Card,
  CardHeader,
  Checkbox,
  List,
  ListItem,
  ListItemText,
  Button,
  CardContent,
} from "@mui/material";
import { Component } from "react";
import CtTxt from "./CustomTool/CtTxt";
import CtTxtPWD from "./CustomTool/CtTxtPWD";
import CtCmb from "./CustomTool/CtCmb";
import CtBtn from "./CustomTool/CtBtn";
import { connect } from "react-redux";
import {
  mapStatetoProps,
  mapSetActiveMenuToProps,
} from "../mapRedux/mapReduxProps";
import { withRouter } from "../HOC/withRouter";
import CtTxtNum from "./CustomTool/CtTxtNum";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import {
  MailTwoTone,
  LocalPhoneTwoTone,
  LockTwoTone,
  LockPersonTwoTone,
  Apartment,
  Person,
  Share,
  Contacts,
  Receipt,
  LocationOn,
} from "@mui/icons-material";
export class Sign_Up extends Component {
  state = {
    formData: {
      txtUserEmail: "",
      txtUsermobNo: "",
      txtPassword: "",
      txtCPassword: "",
      txtCompany: "",
      txtPerson: "",
      cmbReferenceFrom: "Direct",
      txtRefName: "",
      txtGST: "",
      radioGST: "withGst",
      GeneralAccount: true,
      EWay: false,
      Transport: false,
      CommissionAgents: false,
    },
    ReferenceFrom: [
      { vac_referencefrom: "Direct" },
      { vac_referencefrom: "Online" },
      { vac_referencefrom: "Person" },
      { vac_referencefrom: "Dealer" },
      { vac_referencefrom: "Other" },
    ],
    cardData: [
      {
        title: "General Account",
        details: [
          "Billing",
          "Outstanding Reports",
          "Stock Register",
          "Account Reports",
        ],
        id: "GeneralAccount",
      },
      {
        title: "EWay Bill & E-Invoice",
        details: ["E-Way Bill Generation", "E-Invoice Generation"],
        id: "EWay",
      },
      {
        title: "Transport Management",
        details: [
          "Trip Entry",
          "Driver Book",
          "Customer Book",
          "Way Bridge Book",
        ],
        id: "Transport",
      },
      {
        title: "Market Yard Traders & Commission Agents",
        details: [
          "Farmer Bill Entry",
          "Farmer Bill Print",
          "Trader Bill Print",
        ],
        id: "CommissionAgents",
      },
    ],
  };

  //#region Component
  componentDidMount() {
    document.title = "Account Software : Sign Up";
    // this.props.setActiveMenu("OrderEntry");
  }
  //#endregion Component

  handleOnChange = (e) => {
    this.setState({
      formData: { ...this.state.formData, [e.target.name]: e.target.value },
    });
  };

  ValidateSignUp = () => {
    const emailRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    let result = false;
    if (
      Number(this.state.formData.txtGST) <= 0 &&
      this.state.formData.radioGST == "withGst"
    ) {
      this.props.toastErrorMsg("Enter GST No", "txtGST");
    } else if (this.state.formData.txtCompany.length <= 0) {
      this.props.toastErrorMsg("Enter Company", "txtCompany");
    } else if (this.state.formData.txtPerson.length <= 0) {
      this.props.toastErrorMsg("Enter Full Person Name", "txtPerson");
    } else if (this.state.formData.txtUsermobNo.length <= 0) {
      this.props.toastErrorMsg("Enter Mobile Number", "txtUsermobNo");
    } else if (this.state.formData.txtUsermobNo.length <= 9) {
      this.props.toastErrorMsg("Enter Valid Mobile Number", "txtUsermobNo");
    } else if (this.state.formData.txtUserEmail.length <= 0) {
      this.props.toastErrorMsg("Enter Email", "txtUserEmail");
    } else if (!emailRegex.test(this.state.formData.txtUserEmail)) {
      this.props.toastErrorMsg("Enter Valid Email", "txtUserEmail");
    } else if (this.state.formData.txtPassword.length <= 0) {
      this.props.toastErrorMsg("Enter Password", "txtPassword");
    } else if (this.state.formData.txtCPassword.length <= 0) {
      this.props.toastErrorMsg("Enter Confirm Password", "txtCPassword");
    } else if (
      this.state.formData.txtPassword !== this.state.formData.txtCPassword
    ) {
      this.props.toastErrorMsg(
        "Password And ConfirmPassword Must Be Same",
        "txtCPassword"
      );
    } else if (this.state.formData.txtRefName.length <= 0) {
      this.props.toastErrorMsg("Enter Reference Name", "txtRefName");
    } else {
      result = true;
    }
    return result;
  };

  Sign_Up = () => {
    if (this.ValidateSignUp()) {
      alert("Sign Up");
    }
  };
  handleCheckChange = (e) => {
    this.setState({
      formData: {
        ...this.state.formData,
        [e.target.name]: e.target.checked,
      },
    });
  };

  //#region Function

  //#endregion Function

  render() {
    return (
      <div>
        <Grid
          container
          direction="column"
          justifyContent="center"
          alignItems="center"
        >
          <Grid item>
            <Typography
              fontSize="30px"
              display="flex"
              justifyContent="flex-start"
              fontWeight="600"
              color="#05699d"
            >
              Sign Up
            </Typography>
          </Grid>
          <form>
            <Grid
              item
              container
              direction="column"
              justifyContent="center"
              alignItems="center"
              marginTop={0}
              spacing={2}
            >
              <FormControl>
                <RadioGroup
                  row
                  name="radioGST"
                  aria-labelledby="demo-controlled-radio-buttons-group"
                  value={this.state.formData.radioGST}
                  onChange={this.handleOnChange}
                >
                  <FormControlLabel
                    value="withGst"
                    control={<Radio />}
                    label="With GST"
                  />
                  <FormControlLabel
                    value="withoutGst"
                    control={<Radio />}
                    label="Without GST"
                  />
                </RadioGroup>
              </FormControl>
              {this.state.formData.radioGST === "withGst" && (
                <Grid item>
                  <Stack direction="row" spacing={2} alignItems={"center"}>
                    <Grid item>
                      <CtTxt
                        id="txtGST"
                        label="GST No."
                        variant="outlined"
                        handleOnChange={this.handleOnChange}
                        value={this.state.formData.txtGST}
                        width={250}
                        onKeyDown={this.props.onKeyDown}
                        maxLength="15"
                        startAdornment={<Receipt />}
                      />
                    </Grid>
                    <Grid item>
                      <CtBtn
                        id="btnOtpSend"
                        label="Get GST Info"
                        bgColor={"#05699d"}
                      />
                    </Grid>
                  </Stack>
                </Grid>
              )}
              <Grid item>
                <CtTxt
                  id="txtCompany"
                  label="Company Name*"
                  variant="outlined"
                  handleOnChange={this.handleOnChange}
                  value={this.state.formData.txtCompany}
                  width={400}
                  onKeyDown={this.props.onKeyDown}
                  maxLength="100"
                  startAdornment={<Apartment />}
                />
              </Grid>

              {this.state.formData.radioGST === "withGst" && (
                <>
                  <Grid item>
                    <CtTxt
                      id="txtCompanyAddress"
                      label="Company Address*"
                      variant="outlined"
                      handleOnChange={this.handleOnChange}
                      value={this.state.formData.txtCompanyAddress}
                      width={400}
                      onKeyDown={this.props.onKeyDown}
                      maxLength="100"
                      startAdornment={<LocationOn />}
                    />
                  </Grid>
                  <Grid item justifyContent={"flex-start"}>
                    <Stack direction={"row"} spacing={2}>
                      <Grid item>
                        <CtTxt
                          id="txtCompanyAddress"
                          label="State*"
                          variant="outlined"
                          handleOnChange={this.handleOnChange}
                          value={this.state.formData.txtCompanyAddress}
                          width={192}
                          onKeyDown={this.props.onKeyDown}
                          maxLength="100"
                        />
                      </Grid>
                      <Grid item>
                        <CtTxt
                          id="txtCompanyAddress"
                          label="Pincode*"
                          variant="outlined"
                          handleOnChange={this.handleOnChange}
                          value={this.state.formData.txtCompanyAddress}
                          width={192}
                          onKeyDown={this.props.onKeyDown}
                          maxLength="100"
                        />
                      </Grid>
                    </Stack>
                  </Grid>
                </>
              )}
              <Grid item>
                <CtTxt
                  id="txtPerson"
                  label="Person Name*"
                  variant="outlined"
                  handleOnChange={this.handleOnChange}
                  value={this.state.formData.txtPerson}
                  width={400}
                  onKeyDown={this.props.onKeyDown}
                  maxLength="100"
                  startAdornment={<Person />}
                />
              </Grid>
              <Grid item>
                <CtTxtNum
                  id="txtUsermobNo"
                  label="Mobile No.*"
                  type={Number}
                  variant="outlined"
                  handleOnChange={this.handleOnChange}
                  value={this.state.formData.txtUsermobNo}
                  width={400}
                  onKeyDown={this.props.onKeyDown}
                  maxLength="10"
                  startAdornment={<LocalPhoneTwoTone />}
                />
              </Grid>
              <Grid item>
                <CtTxt
                  id="txtUserEmail"
                  label="Email*"
                  variant="outlined"
                  handleOnChange={this.handleOnChange}
                  value={this.state.formData.txtUserEmail}
                  width={400}
                  onKeyDown={this.props.onKeyDown}
                  maxLength="100"
                  startAdornment={<MailTwoTone />}
                />
              </Grid>
              {/* <label>Note : Your Email ID will be User ID</label> */}
              <Grid item>
                <CtTxtPWD
                  id="txtPassword"
                  label="Password"
                  variant="outlined"
                  handleOnChange={this.handleOnChange}
                  value={this.state.formData.txtPassword}
                  type="password"
                  width={400}
                  onKeyDown={this.props.onKeyDown}
                  maxLength="50"
                  startAdornment={<LockTwoTone />}
                />
              </Grid>
              <Grid item>
                <CtTxtPWD
                  id="txtCPassword"
                  label="Confirm Password"
                  variant="outlined"
                  handleOnChange={this.handleOnChange}
                  value={this.state.formData.txtCPassword}
                  type="password"
                  width={400}
                  onKeyDown={this.props.onKeyDown}
                  maxLength="50"
                  startAdornment={<LockPersonTwoTone />}
                />
              </Grid>
              <Grid item>
                <CtCmb
                  id="cmbReferenceFrom"
                  label="Reference From"
                  variant="outlined"
                  items={this.state.ReferenceFrom}
                  value={this.state.formData.cmbReferenceFrom}
                  onKeyDown={this.props.onKeyDown}
                  handleOnChange={this.handleOnChange}
                  width={400}
                  maxLength="50"
                  colID={"vac_referencefrom"}
                  nextCtrlID="btnOtpSend"
                  startAdornment={<Share />}
                />
              </Grid>
              <Grid item>
                <CtTxt
                  id="txtRefName"
                  label="Ref. Name*"
                  variant="outlined"
                  handleOnChange={this.handleOnChange}
                  value={this.state.formData.txtRefName}
                  width={400}
                  onKeyDown={this.props.onKeyDown}
                  maxLength="100"
                  startAdornment={<Contacts />}
                />
              </Grid>
              <Grid item>
                <Grid container spacing={3}>
                  {this.state.cardData.map((card, index) => (
                    <Grid item xs={6} sm={6} md={6} lg={6} key={index}>
                      <Card
                        variant="outlined"
                        sx={{
                          height: "100%",
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >
                        <CardHeader
                          style={{ padding: "8px 12px 4px 12px" }}
                          title={
                            <FormControlLabel
                              id={card.id}
                              name={card.id}
                              checked={this.state.formData[card.id]}
                              disabled={
                                card.id == "GeneralAccount" ? true : false
                              }
                              control={<Checkbox />}
                              onChange={this.handleCheckChange}
                              label={
                                <Typography
                                  fontSize={"16px"}
                                  fontWeight={"bold"}
                                >
                                  {card.title}
                                </Typography>
                              }
                            />
                          }
                        />
                        <CardContent
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            height: "100%",
                            padding: "0px 12px",
                          }}
                        >
                          <List dense sx={{ flexGrow: 1 }}>
                            {card.details.map((item, idx) => (
                              <ListItem key={idx} disablePadding>
                                <ListItemText primary={item} />
                              </ListItem>
                            ))}
                          </List>
                          <Button
                            variant="outlined"
                            size="small"
                            sx={{ mt: 1 }}
                            fullWidth
                          >
                            See More
                          </Button>
                        </CardContent>
                      </Card>
                    </Grid>
                  ))}
                </Grid>
              </Grid>

              <Grid item>
                <CtBtn
                  id="btnOtpSend"
                  label="Sign Up"
                  bgColor={"#05699d"}
                  onClick={this.Sign_Up}
                />
              </Grid>
            </Grid>
          </form>
        </Grid>
        <Grid item>
          <Box
            display={{ xs: "none" }}
            style={{ textAlign: "center", justifyContent: "center" }}
          >
            {this.state.ARD}
          </Box>
        </Grid>
      </div>
    );
  }
}

export default connect(
  mapStatetoProps,
  mapSetActiveMenuToProps
)(HoCtToastContainer(withRouter(Sign_Up)));
